module.exports = __webpack_public_path__ + "static/media/logo-cielo.e5676eb0.png";